// in src/App.js
import React from 'react';
import {Admin, Resource} from 'admin-on-rest';
import Login from './Login';
import authClient from './authClient';
import FuseLayout from './Fuse/admin/FuseLayout';
import {AppTitle} from './Fuse/global/title';
import {MainMenu} from './Fuse/global/menu';
import {FuseFooter} from './Fuse/global/footer';
import {
    fuseRestClient,
    fuseDashboard
} from './Fuse'
import NotFound from './Fuse/notFound';
import fuseReducer from './Fuse/admin/fuseReducer';
import fuseSaga from './Fuse/admin/fuseSaga';
import customRoutes from "./routes"

import {
    fuseSystemList,
    fuseSystemShow,
    fuseSystemCreate,
    fuseSystemEdit
} from "./Fuse/System/system";
import {
    fuseSystemOperatorList,
    fuseSystemOperatorShow,
    fuseSystemOperatorCreate,
    fuseSystemOperatorEdit
} from "./Fuse/System/sysOp";
import {
    fuseSystemAdminList,
    fuseSystemAdminShow,
    fuseSystemAdminCreate,
    fuseSystemAdminEdit
} from "./Fuse/System/sysAdmin";
import {
    fuseSystemUserList,
    fuseSystemUserShow,
    fuseSystemUserCreate,
    fuseSystemUserEdit
} from "./Fuse/System/sysUser";

import getMuiTheme from 'material-ui/styles/getMuiTheme';
import FuseTheme from './Fuse/global/theme';

const App = () => (
    <Admin title={<AppTitle/>}
           key="Admin"
           theme={getMuiTheme(FuseTheme)}
           appLayout={FuseLayout}
           dashboard={fuseDashboard}
           menu={MainMenu}
           restClient={fuseRestClient({})}
           loginPage={Login}
           customRoutes={customRoutes}
           customReducers={{fuse: fuseReducer}}
           customSagas={[fuseSaga]}
           authClient={authClient}
           catchAll={NotFound}
           footer={FuseFooter}
    >
        {/*{permissions => [*/}
        {/*permissions === 'user' ? (*/}
        {/**/}
        {/*) : null,*/}
        {/*]}*/}

        {/* System Resources */}
        <Resource name="Systems" options={{label: 'Systems'}}
                  list={fuseSystemList} show={fuseSystemShow}
                  create={fuseSystemCreate} edit={fuseSystemEdit}/>
        <Resource name="Sysops" options={{label: 'Sysops'}}
                  list={fuseSystemOperatorList} show={fuseSystemOperatorShow}
                  create={fuseSystemOperatorCreate} edit={fuseSystemOperatorEdit}/>
        <Resource name="Sysadmins" options={{label: 'Sysadmins'}}
                  list={fuseSystemAdminList} show={fuseSystemAdminShow}
                  create={fuseSystemAdminCreate} edit={fuseSystemAdminEdit}/>
        <Resource name="Sysusers" options={{label: 'Sysusers'}}
                  list={fuseSystemUserList} show={fuseSystemUserShow}
                  create={fuseSystemUserCreate} edit={fuseSystemUserEdit}/>
    </Admin>
);

export default App;


// WEBPACK FOOTER //
// ./src/App.js